<div class="form-group" [ngClass]="{ 'mt-2': !title }">
  <!-- control label -->
  <label
    [for]="id"
    class="form-label"
    *ngIf="title"
    [translatable]="{
      transKey: labelTranslationKey,
      modEnum: labelTranslationModuleEnum
    }"
  >
    {{ title }}
    <span [ngClass]="{ 'astrix-red': isRequired, 'no-astrix': !isRequired }">
      *
    </span>
  </label>

  <!-- percent input -->
  <nz-input-group
    [nzSuffix]="suffix"
    [translatable]="{
      transKey: placeholderTranslationKey,
      modEnum: placeholderTranslationModuleEnum
    }"
  >
    <input
      type="text"
      nz-input
      [(ngModel)]="value"
      class="percentage-field form-control test w-100"
      [type]="'number'"
      [min]="minValue"
      [max]="maxValue"
      [ngStyle]="style"
      [ngClass]="{ valid: control?.valid }"
      [id]="id"
      [dir]="dir"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (keyup)="keyup()"
      (keyup.enter)="keyup()"
      (input)="change()"
      (blur)="focus()"
      [(ngModel)]="value"
    />
  </nz-input-group>
</div>

<ng-container *ngIf="!!showValidations">
  <app-validation
    *ngIf="(control?.touched || isSubmitted) && control?.invalid"
    [title]="title"
    [control]="control"
    [length]="length"
    [minLength]="minLength"
    [valideMax]="validMax"
    [minValue]="minValue"
    [maxLength]="maxLength"
  ></app-validation>
</ng-container>
